import React, { useState, useEffect, useRef } from 'react';
import { ArrowLeft, Eye, ArrowRight, Plane, Heart, MapPin, Calendar, Camera, Star, Globe, Play, Pause } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const VideoAdContent = ({ isInPreview = false, isExpanded = false, onExpand, onClose }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleExpand = () => {
    if (onExpand && !isInPreview) {
      onExpand();
    }
  };

  return (
    <div className={`w-full h-full relative overflow-hidden ${isExpanded ? 'fixed inset-0 z-50 bg-black' : ''}`}>
      {!isExpanded ? (
        <div className="relative h-full">
          {/* Compact Video Ad */}
          <div 
            className={`relative cursor-pointer transform transition-all duration-300 ${
              !isInPreview ? 'hover:scale-105' : ''
            } w-full h-full`}
            onClick={handleExpand}
            onMouseEnter={() => setShowControls(true)}
            onMouseLeave={() => setShowControls(false)}
          >
            {/* Video Container */}
            <div className="relative w-full h-full  overflow-hidden">
              <video
                ref={videoRef}
                className="w-full h-full object-cover"
                muted
                loop
                playsInline
                autoPlay
                // onPlay={() => setIsPlaying(true)}
                // onPause={() => setIsPlaying(false)}
              >
                <source src="/assets/tiger.MP4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>

              {/* Play/Pause Overlay */}
              {/* <div 
                className={`absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center transition-opacity duration-300 ${
                  showControls || !isPlaying ? 'opacity-100' : 'opacity-0'
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  handlePlayPause();
                }}
              > */}
                {/* <div className="w-12 h-12 bg-white bg-opacity-80 rounded-full flex items-center justify-center hover:bg-opacity-100 transition-all duration-200">
                  {isPlaying ? (
                    <Pause size={24} className="text-gray-800" />
                  ) : (
                    <Play size={24} className="text-gray-800 ml-1" />
                  )}
                </div> */}
              {/* </div> */}

              {/* Ad Label */}
              <div className="absolute top-2 left-2 bg-black bg-opacity-60 text-white px-2 py-1 rounded text-xs font-medium">
                AD
              </div>

              {/* Brand/CTA Overlay */}
              {/* <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black via-black/50 to-transparent p-3">
                <div className="text-white">
                  <h4 className="font-bold text-sm mb-1">Premium Content</h4>
                  <p className="text-xs text-white/80 mb-2">Experience the difference</p>
                  <button className="bg-white text-black px-3 py-1 rounded-full text-xs font-medium hover:bg-gray-200 transition-colors">
                    Learn More
                  </button>
                </div>
              </div> */}
            </div>

            {/* Click to expand hint */}
            {/* {!isInPreview && showControls && (
              <div className="absolute -top-8 left-1/2 transform -translate-x-1/2 animate-bounce">
                <div className="bg-black/70 text-white px-3 py-1 rounded-full text-xs whitespace-nowrap">
                  Click to expand!
                </div>
              </div>
            )} */}
          </div>
        </div>
      ) : (
        /* Expanded Video Experience - Full Screen */
        <div className="w-full h-full flex items-center justify-center relative">
          {/* <button
            onClick={onClose}
            className="absolute top-4 right-4 w-10 h-10 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center text-white text-xl font-bold transition-all duration-300 hover:scale-110 z-10"
          >
            ×
          </button> */}
          
          <div className="relative w-full h-full max-w-4xl">
            <video
              ref={videoRef}
              className="w-full h-full object-contain"
              controls
              autoPlay
              muted
              loop
              playsInline
            >
              <source src="/assets/tiger.MP4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            {/* Brand overlay for expanded view */}
            {/* <div className="absolute bottom-4 left-4 bg-black/60 backdrop-blur-sm rounded-lg p-4 text-white">
              <h3 className="text-xl font-bold mb-2">Premium Experience</h3>
              <p className="text-sm opacity-80 mb-3">Discover what makes us different</p>
              <button className="bg-white text-black px-6 py-2 rounded-full font-medium hover:bg-gray-200 transition-colors">
                Get Started
              </button>
            </div> */}
          </div>
        </div>
      )}
    </div>
  );
};

function TigerDetail() {
  const [isMobile, setIsMobile] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
 <Helmet>
           <title>
    Tiger Campaign | Video Ad Showcase by Bidbox
            </title>
            <meta
              name="description"
              content="See how Tiger campaigns come alive with Video ads on Bidbox. Explore powerful storytelling & impactful visuals that drive audience engagement"
            />
            {/* <meta
              name="keywords"
              content="BidBox AI, Demand-Side Platform, DSP solutions, targeted advertising, ad campaign optimization, programmatic advertising, real-time bidding, ad tech, audience segmentation, AI-driven advertising, digital marketing, performance marketing, cross-channel advertising, ad exchange, ad placement, ad inventory, ad network, data-driven marketing, media buying."
            /> */}
             <link
              rel="canonical"
              href="https://bidbox.ai/video/tiger"
            />
            <meta
              name="robots"
              content="max-snippet:-1, max-image-preview:standard"
            />
            <meta name="robots" content="max-video-preview:-1" />
        </Helmet>


        <div className="min-h-screen bg-gray-50 mt-10">
      <div className="container mx-auto px-4 py-8 lg:py-12">
        <div className="flex flex-col lg:flex-row lg:items-start lg:space-x-12">
          {/* Left column - Content */}
          <div className="flex-1 lg:max-w-lg">
            {/* Header */}
            <header className="animate-slide-up">
              {/* Back to Ad Gallery */}
              <div className="mb-6 lg:mb-8">
                {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform duration-200" />
                  <span className="text-sm font-medium">Back to Ad Gallery</span>
                </button> */}
              </div>

              {/* Title and tag */}
              <div className="mb-4 lg:mt-16 md:mt-10 sm:mt-0">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 leading-tight">
                  Power in Motion. Story in Every Frame.
                  </h1>
                  <span className="bg-blue-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    Video
                  </span>
                </div>
                
                {/* View in preview site */}
                {/* <button className="flex items-center space-x-2 text-blue-500 hover:text-blue-600 transition-colors duration-200 group">
                  <Eye className="w-4 h-4" />
                  <span className="text-sm font-medium group-hover:underline">View in preview site</span>
                </button> */}
              </div>
            </header>

            {/* Content Section */}
            <div className="animate-slide-up" style={{ animationDelay: '0.2s' }}>
              {/* Make it yours section */}
              <div className="mb-8">
                <h2 className="text-lg font-bold text-blue-600 mb-4 tracking-wide">
                  MAKE IT YOURS!
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6 max-w-md">
                This interactive video ad brings your product to life through bold visuals and seamless playback. Designed to showcase energy and style, it’s perfect for brand storytelling and product highlights. Just insert your video and message to launch an experience that feels as dynamic as the product itself.
                </p>
                
                {/* CTA Button */}
                <Link to='/contact'>
                <button className="group bg-white border-2 border-blue-500 text-blue-500 px-6 py-3 rounded-full font-medium hover:bg-blue-500 hover:text-white transition-all duration-300 flex items-center space-x-2 shadow-sm hover:shadow-md transform hover:-translate-y-0.5">
                  <span>Start with this Template</span>
                  <ArrowRight className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-200" />
                </button>
                </Link>
              </div>
            </div>
          </div>

          {/* Right column - Template Preview */}
          <div className="flex-1 lg:max-w-2xl mt-8 lg:mt-0">
            {/* Preview toggle */}
            <div className="hidden lg:flex justify-center mt-2 animate-fade-in mb-4" style={{ animationDelay: '0.3s' }}>
              <div className="bg-white rounded-full px-6 py-3 shadow-lg border border-gray-200">
                <div className="flex items-center space-x-4">
                  {/* <span className="text-sm text-gray-600 font-medium">Preview in:</span> */}
                  <div className="flex items-center space-x-3">
                    <span className={`text-sm font-medium transition-colors ${isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                      Mobile
                    </span>
                    <button
                      onClick={() => setIsMobile(!isMobile)}
                      className="relative w-12 h-6 bg-blue-500 rounded-full transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                    >
                      <div className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-200 ${isMobile ? 'left-1' : 'left-7'}`}></div>
                    </button>
                    <span className={`text-sm font-medium transition-colors ${!isMobile ? 'text-blue-600' : 'text-gray-600'}`}>
                      Desktop
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative animate-fade-in" style={{ animationDelay: '0.4s' }}>
              {/* Mobile Mockup */}
              {isMobile && (
                <div className="mx-auto max-w-xs">
                  {/* iPhone mockup */}
                  <div className="relative rounded-[2.5rem] p-2 shadow-2xl">
                    {/* Status bar area */}
                    <div className="bg-white rounded-[2rem] overflow-hidden">
                      {/* Status bar */}
                      <div className="bg-white px-6 py-2 flex justify-between items-center text-black text-sm font-medium">
                        <span>9:41</span>
                        <div className="flex items-center space-x-1">
                          <div className="flex space-x-1">
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                            <div className="w-1 h-1 bg-black rounded-full"></div>
                          </div>
                          <div className="w-6 h-3 border border-black rounded-sm relative">
                            <div className="w-4/5 h-full bg-green-500 rounded-sm"></div>
                          </div>
                        </div>
                      </div>

                      {/* Browser bar */}
                      <div className="bg-gray-100 px-4 py-3 flex items-center space-x-3">
                        <div className="flex-1 bg-white rounded-lg px-3 py-2 text-sm text-gray-600 flex items-center justify-center">
                          publisher.com
                        </div>
                      </div>

                      {/* Content area */}
                      <div className="p-4 bg-gray-50 h-[400px] overflow-y-auto hide-scrollbar">
                      <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          

                        </div>
                        {/* Video Ad - Full width on mobile with same gap from top */}
                        <div className="mb-6">
                          <div className="h-48 rounded-lg overflow-hidden">
                            <VideoAdContent 
                              isInPreview={true}
                              isExpanded={isExpanded}
                              onExpand={() => setIsExpanded(true)}
                              onClose={() => setIsExpanded(false)}
                            />
                          </div>
                        </div>

                        {/* Additional content placeholders */}
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                         

                        </div>
                        <div className="space-y-3">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                        <div className="space-y-3 mt-2">
                          <div className="h-3 bg-gray-200 rounded w-full"></div>
                          <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                          <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Desktop Mockup */}
              {!isMobile && (
                <div className="w-full max-w-2xl mx-auto">
                  {/* Desktop Screen Frame */}
                  <div className="bg-gray-200 rounded-xl p-3 shadow-2xl">
                    {/* Screen */}
                    <div className="bg-white rounded-lg overflow-hidden shadow-inner" style={{ aspectRatio: '16/10' }}>
                      {/* macOS-style window header */}
                      <div className="bg-gray-100 px-1 py-1 flex items-center border-b border-gray-200">
                        <div className="flex space-x-2">
                          <div className="w-3 h-3 bg-red-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-yellow-400 rounded-full"></div>
                          <div className="w-3 h-3 bg-green-400 rounded-full"></div>
                        </div>
                        <div className="flex-1 mx-6">
                          <div className="bg-white rounded-md px-1 py-1 text-sm text-gray-600 border shadow-sm max-w-md">
                            🔒 publisher.com
                          </div>
                        </div>
                        <div className="flex space-x-1">
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                          <div className="w-4 h-4 bg-gray-300 rounded"></div>
                        </div>
                      </div>

                      {/* Browser content area */}
                      <div className="p-1 bg-gray-50 h-[500px] overflow-y-auto hide-scrollbar">
                        {/* Page header */}
                        <div className="mb-2">
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>
                            <div className="h-4 bg-gray-200 rounded w-5/6 mb-2"></div>

                          </div>

                        {/* Video Ad positioned in content with same gap from top */}
                        <div className="flex justify-center mb-2">
                          <div className="w-80 h-48  overflow-hidden">
                            <VideoAdContent 
                              isInPreview={true}
                              isExpanded={isExpanded}
                              onExpand={() => setIsExpanded(true)}
                              onClose={() => setIsExpanded(false)}
                            />
                          </div>
                        </div>

                        {/* Additional content placeholders */}
                        <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                          {/* Sidebar placeholders */}
                          <div className="grid grid-cols-3 gap-4">
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                            <div className="h-24 bg-gray-200 rounded"></div>
                          </div>
                          <div className="grid grid-cols-2 gap-6 mb-6">
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                          <div className="space-y-3">
                            <div className="h-4 bg-gray-200 rounded w-full"></div>
                            <div className="h-3 bg-gray-200 rounded w-5/6"></div>
                            <div className="h-3 bg-gray-200 rounded w-4/6"></div>
                          </div>
                        </div>

                        {/* Sidebar placeholders */}
                        <div className="grid grid-cols-3 gap-4">
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                          <div className="h-24 bg-gray-200 rounded"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Monitor stand */}
                  <div className="flex justify-center">
                    <div className="w-20 h-4 bg-gray-200 rounded-b-lg"></div>
                  </div>
                  <div className="flex justify-center">
                    <div className="w-32 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Expanded Video Overlay */}
      {isExpanded && (
        <div className="fixed inset-0 z-50">
          <VideoAdContent 
            isExpanded={true}
            onClose={() => setIsExpanded(false)}
          />
        </div>
      )}

      <style jsx>{`
        @keyframes slide-up {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        .animate-slide-up {
          animation: slide-up 0.6s ease-out forwards;
        }
        
        .animate-fade-in {
          animation: fade-in 0.6s ease-out forwards;
        }
      `}</style>
    </div>
   <div className="max-w-7xl mx-auto px-4 py-10">
                       <h1 className="text-3xl font-bold text-center text-gray-800 mb-10">Discover More Ads</h1>
                 
                       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                         {/* Card 1 */}
                         <Link to="/3d-prism/prism" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                           <img
                             src="/assets/prism11.jpg"
                             alt="Card 1"
                             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                           />
                           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                             <h2 className="text-lg font-semibold">Prism</h2>
                           </div>
                         </Link>
                 
                         {/* Card 2 */}
                         <Link to="/360rotate/carrotate" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                           <img
                             src="/assets/car121.webp"
                             alt="Card 2"
                             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                           />
                           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                             <h2 className="text-lg font-semibold">Car 360</h2>
                           </div>
                         </Link>
                 
                         {/* Card 3 */}
                         <Link to="/hotspot/luxarycloset" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                           <img
                             src="/assets/luxary.webp"
                             alt="Card 3"
                             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                           />
                           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                             <h2 className="text-lg font-semibold">Luxary Closet</h2>
                           </div>
                         </Link>
                 
                         {/* Card 4 */}
                         <Link to="/native-display/pepsi" className="block group rounded-xl overflow-hidden shadow-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-2xl">
                           <img
                             src="assets/pepsi.webp"
                             alt="Card 4"
                             className="w-full h-60 object-cover transition-opacity duration-300 group-hover:opacity-80"
                           />
                           <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent text-white p-4 opacity-0 group-hover:opacity-100 transition-all duration-300">
                             <h2 className="text-lg font-semibold">Pepsi</h2>
                           </div>
                         </Link>
                 
                        
                       </div>
                     </div>
    </>
  );
}

export default TigerDetail;    
    



// import React, { useState, useEffect } from 'react';
// import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode, Play, Pause, Volume2, VolumeX, Maximize2, Eye, Download, Share2 } from 'lucide-react';

// const TigerDetail = () => {
//   const [selectedAdId, setSelectedAdId] = useState(2);
//   const [viewMode, setViewMode] = useState('desktop');
//   const [isPlaying, setIsPlaying] = useState(true);
//   const [isMuted, setIsMuted] = useState(true);
//   const [showPreview, setShowPreview] = useState(false);
//   const [videoError, setVideoError] = useState(false);

//   const adFormats = [
//     {
//       id: 1,
//       name: 'Video Banner',
//       dimension: '300x250',
//       type: 'Video Banner',
//       creativeId: '1552639',
//       gradient: 'from-rose-400 via-pink-500 to-purple-600',
//       video: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4'
//     },
//     {
//       id: 2,
//       name: 'Video Banner',
//       dimension: '300x600',
//       type: 'Video Banner',
//       creativeId: '1552640',
//       gradient: 'from-cyan-400 via-blue-500 to-indigo-600',
//       video: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4'
//     },
//     {
//       id: 3,
//       name: 'Video Banner',
//       dimension: '320x480',
//       type: 'Video Banner',
//       creativeId: '1552641',
//       gradient: 'from-violet-500 via-purple-600 to-pink-600',
//       video: 'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4'
//     }
//   ];

//   const currentAd = adFormats.find(ad => ad.id === selectedAdId) || adFormats[1];

//   useEffect(() => {
//     setShowPreview(true);
//     setVideoError(false);
//   }, [selectedAdId]);

//   const selectAd = (adId) => {
//     setShowPreview(false);
//     setTimeout(() => {
//       setSelectedAdId(adId);
//     }, 150);
//   };

//   const nextAd = () => {
//     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
//     const nextIndex = currentIndex === adFormats.length - 1 ? 0 : currentIndex + 1;
//     selectAd(adFormats[nextIndex].id);
//   };

//   const prevAd = () => {
//     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
//     const prevIndex = currentIndex === 0 ? adFormats.length - 1 : currentIndex - 1;
//     selectAd(adFormats[prevIndex].id);
//   };

//   const AdContent = ({ className = "" }) => {
//     const handleVideoError = () => {
//       setVideoError(true);
//     };

//     const renderFallbackContent = () => (
//       <div className={`bg-gradient-to-br ${currentAd.gradient} flex items-center justify-center text-white text-center h-full w-full`}>
//         <div className="animate-pulse">
//           <div className="text-3xl mb-3">✈️</div>
//           <div className="text-xl font-bold mb-2">Video Banner</div>
//           <div className="text-sm opacity-80">Widen Your World</div>
//         </div>
//       </div>
//     );

//     return (
//       <div className={`relative group ${className}`}>
//         {currentAd.dimension === '300x250' && (
//           <div className="w-[300px] h-[250px] rounded-2xl overflow-hidden shadow-2xl relative">
//             {!videoError ? (
//               <video
//                 // autoPlay={isPlaying}
//                 // muted={isMuted}
//                 autoPlay
//                 muted
//                 loop
//                 playsInline
//                 className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                 onError={handleVideoError}
//               >
//                 <source src={currentAd.video} type="video/mp4" />
//               </video>
//             ) : (
//               renderFallbackContent()
//             )}
//             <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
//               <div className="flex space-x-2">
//                 <button 
//                   onClick={() => setIsPlaying(!isPlaying)}
//                   className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
//                 >
//                   {isPlaying ? <Pause size={16} /> : <Play size={16} />}
//                 </button>
//                 <button 
//                   onClick={() => setIsMuted(!isMuted)}
//                   className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
//                 >
//                   {isMuted ? <VolumeX size={16} /> : <Volume2 size={16} />}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
        
//         {currentAd.dimension === '300x600' && (
//           <div className="w-[300px] h-[600px] rounded-2xl overflow-hidden shadow-2xl relative">
//             {!videoError ? (
//               <video
//               autoPlay
//               muted
//               loop
//               playsInline
                
//                 className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                 onError={handleVideoError}
//               >
//                 <source src={currentAd.video} type="video/mp4" />
//               </video>
//             ) : (
//               renderFallbackContent()
//             )}
//             <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
//               <div className="flex space-x-2">
//                 <button 
//                   onClick={() => setIsPlaying(!isPlaying)}
//                   className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
//                 >
//                   {isPlaying ? <Pause size={18} /> : <Play size={18} />}
//                 </button>
//                 <button 
//                   onClick={() => setIsMuted(!isMuted)}
//                   className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
//                 >
//                   {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
        
//         {currentAd.dimension === '320x480' && (
//           <div className="w-[320px] h-[480px] rounded-2xl overflow-hidden shadow-2xl relative">
//             {!videoError ? (
//               <video
//               autoPlay
//               muted
//               loop
//               playsInline
//                 className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
//                 onError={handleVideoError}
//               >
//                 <source src={currentAd.video} type="video/mp4" />
//               </video>
//             ) : (
//               renderFallbackContent()
//             )}
//             <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100">
//               <div className="flex space-x-2">
//                 <button 
//                   onClick={() => setIsPlaying(!isPlaying)}
//                   className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
//                 >
//                   {isPlaying ? <Pause size={18} /> : <Play size={18} />}
//                 </button>
//                 <button 
//                   onClick={() => setIsMuted(!isMuted)}
//                   className="bg-white/90 hover:bg-white text-gray-800 p-2 rounded-full shadow-lg transition-all transform hover:scale-110"
//                 >
//                   {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-indigo-50/50 overflow-x-hidden mt-14">
//       {/* Animated Background Elements */}
//       <div className="fixed inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-300/20 rounded-full blur-3xl animate-pulse"></div>
//         <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-300/20 rounded-full blur-3xl animate-pulse" style={{animationDelay: '2s'}}></div>
//         <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-72 h-72 bg-pink-300/10 rounded-full blur-3xl animate-pulse" style={{animationDelay: '4s'}}></div>
//       </div>

//       <div className="relative z-10 flex min-h-screen max-w-full overflow-x-hidden">
//         {/* Left Sidebar */}
//         <div className="w-80 bg-white/80 backdrop-blur-xl border-r border-white/20 shadow-xl hidden lg:block flex-shrink-0">
//           <div className="p-6">
//             {/* Header */}
//             <div className="mb-8">
//               <div className="flex items-center space-x-3 mb-4">
//                 <div className="w-3 h-3 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full animate-pulse"></div>
//                 <h2 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">Creative Suite</h2>
//               </div>
//               <p className="text-sm text-gray-500">Video Banner Campaign</p>
//             </div>

//             {/* Ad Formats */}
//             <div className="space-y-3">
//               {adFormats.map((ad, index) => (
//                 <div 
//                   key={ad.id}
//                   onClick={() => selectAd(ad.id)}
//                   className={`group p-4 rounded-2xl cursor-pointer transition-all duration-300 transform hover:scale-[1.02] ${
//                     ad.id === selectedAdId
//                       ? 'bg-gradient-to-r from-blue-500/20 to-purple-500/20 border-2 border-blue-300/50 shadow-lg' 
//                       : 'bg-white/60 border border-gray-200/50 hover:bg-white/80 hover:border-gray-300/50'
//                   }`}
//                   style={{animationDelay: `${index * 100}ms`}}
//                 >
//                   <div className="flex items-center space-x-4">
//                     {/* Thumbnail */}
//                     <div className="relative flex-shrink-0">
//                       {ad.dimension === '300x250' && (
//                         <div className={`w-16 h-12 bg-gradient-to-br ${ad.gradient} rounded-lg shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow`}>
//                           <Play size={12} className="text-white" />
//                         </div>
//                       )}
//                       {ad.dimension === '300x600' && (
//                         <div className={`w-10 h-20 bg-gradient-to-b ${ad.gradient} rounded-lg shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow`}>
//                           <Play size={10} className="text-white" />
//                         </div>
//                       )}
//                       {ad.dimension === '320x480' && (
//                         <div className={`w-12 h-16 bg-gradient-to-br ${ad.gradient} rounded-lg shadow-md flex items-center justify-center group-hover:shadow-lg transition-shadow`}>
//                           <Play size={10} className="text-white" />
//                         </div>
//                       )}
//                       {ad.id === selectedAdId && (
//                         <div className="absolute -top-1 -right-1 w-4 h-4 bg-green-500 border-2 border-white rounded-full animate-bounce"></div>
//                       )}
//                     </div>
                    
//                     {/* Details */}
//                     <div className="flex-1 min-w-0">
//                       <div className="text-sm font-semibold text-gray-800 truncate mb-1">
//                         {ad.name}
//                       </div>
//                       <div className="text-xs text-blue-600 font-medium">
//                         {ad.dimension}
//                       </div>
//                       <div className="text-xs text-gray-500">
//                         {ad.type}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ))}
//             </div>

//             {/* Action Buttons */}
//             <div className="mt-8 pt-6 border-t border-gray-200/50">
//               <button className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4 rounded-xl font-medium hover:from-blue-700 hover:to-purple-700 transition-all duration-200 transform hover:scale-[1.02] shadow-lg">
//                 Export All Creatives
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Main Content */}
//         <div className="flex-1 flex flex-col min-w-0">
//           {/* Header */}
//           <header className="bg-white/80 backdrop-blur-xl border-b border-white/20 shadow-sm">
//             <div className="px-4 sm:px-6 py-4">
//               <div className="flex items-center justify-between flex-wrap gap-4">
//                 <div className="flex items-center space-x-4 min-w-0">
//                   <h1 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent truncate">
//                     Ad Preview Studio
//                   </h1>
//                   <div className="flex items-center space-x-2 text-sm text-gray-500">
//                     <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
//                     <span className="hidden sm:inline">Live Preview</span>
//                   </div>
//                 </div>
                
//                 {/* View Mode Toggle */}
//                 <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
//                   <div className="bg-gray-100/80 backdrop-blur-sm rounded-xl p-1 flex">
//                     <button
//                       onClick={() => setViewMode('mobile')}
//                       className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 ${
//                         viewMode === 'mobile' 
//                           ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-md transform scale-105' 
//                           : 'text-gray-600 hover:bg-white/60'
//                       }`}
//                     >
//                       <Smartphone size={16} />
//                       <span className="hidden sm:inline">Mobile</span>
//                     </button>
//                     <button
//                       onClick={() => setViewMode('desktop')}
//                       className={`flex items-center space-x-1 sm:space-x-2 px-2 sm:px-4 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all duration-200 ${
//                         viewMode === 'desktop' 
//                           ? 'bg-gradient-to-r from-gray-800 to-gray-600 text-white shadow-md transform scale-105' 
//                           : 'text-gray-600 hover:bg-white/60'
//                       }`}
//                     >
//                       <Monitor size={16} />
//                       <span className="hidden sm:inline">Desktop</span>
//                     </button>
//                   </div>

//                   {/* Action Buttons */}
//                   <div className="flex items-center space-x-2">
//                     <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-white/60 rounded-lg transition-all">
//                       <Eye size={18} />
//                     </button>
//                     <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-white/60 rounded-lg transition-all">
//                       <Download size={18} />
//                     </button>
//                     <button className="p-2 text-gray-600 hover:text-gray-800 hover:bg-white/60 rounded-lg transition-all">
//                       <Share2 size={18} />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </header>

//           {/* Content Area */}
//           <div className="flex-1 flex overflow-hidden">
//             {/* Preview Area */}
//             <div className="flex-1 p-4 lg:p-8 overflow-hidden">
//               {/* Navigation */}
//               <div className="flex items-center justify-center space-x-4 lg:space-x-6 mb-6 lg:mb-8">
//                 <button 
//                   onClick={prevAd}
//                   className="group flex items-center space-x-2 px-3 sm:px-4 lg:px-6 py-2 lg:py-3 bg-white/60 backdrop-blur-sm text-gray-700 hover:text-gray-900 hover:bg-white/80 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-sm hover:shadow-md"
//                 >
//                   <ChevronLeft size={20} className="group-hover:-translate-x-1 transition-transform" />
//                   <span className="font-medium hidden sm:inline">Previous</span>
//                 </button>
                
//                 <div className="flex items-center space-x-3 px-4 lg:px-6 py-2 lg:py-3 bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-sm rounded-xl">
//                   <div className="text-sm font-bold text-gray-800">
//                     {adFormats.findIndex(ad => ad.id === selectedAdId) + 1}
//                   </div>
//                   <div className="w-1 h-4 bg-gray-400 rounded-full"></div>
//                   <div className="text-sm text-gray-600">
//                     of {adFormats.length}
//                   </div>
//                 </div>
                
//                 <button 
//                   onClick={nextAd}
//                   className="group flex items-center space-x-2 px-3 sm:px-4 lg:px-6 py-2 lg:py-3 bg-white/60 backdrop-blur-sm text-gray-700 hover:text-gray-900 hover:bg-white/80 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-sm hover:shadow-md"
//                 >
//                   <span className="font-medium hidden sm:inline">Next</span>
//                   <ChevronRight size={20} className="group-hover:translate-x-1 transition-transform" />
//                 </button>
//               </div>

//               {/* Preview Container */}
//               <div className="flex items-center justify-center overflow-hidden">
//                 <div className={`transition-all duration-500 ${showPreview ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
//                   {viewMode === 'mobile' ? (
//                     // Mobile Preview
//                     <div className="transform hover:scale-105 transition-transform duration-300">
//                       <div className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-[2rem] lg:rounded-[3rem] p-2 lg:p-3 shadow-2xl">
//                         <div className="bg-black rounded-[1.5rem] lg:rounded-[2.5rem] overflow-hidden w-[280px] sm:w-[300px] h-[600px] sm:h-[650px]">
//                           {/* Notch */}
//                           <div className="h-6 lg:h-8 bg-black relative">
//                             <div className="absolute top-1 lg:top-2 left-1/2 transform -translate-x-1/2 w-20 sm:w-24 lg:w-32 h-3 lg:h-4 bg-gray-900 rounded-full"></div>
//                           </div>
                          
//                           {/* Status Bar */}
//                           <div className="bg-white px-4 lg:px-6 py-1 lg:py-2 flex justify-between items-center text-xs lg:text-sm font-medium">
//                             <span>10:59 AM</span>
//                             <div className="flex items-center space-x-2">
//                               <span className="text-xs">5G</span>
//                               <div className="flex space-x-1">
//                                 {[1,2,3,4].map(i => (
//                                   <div key={i} className={`w-1 h-2 lg:h-3 rounded-full ${i <= 3 ? 'bg-black' : 'bg-gray-300'}`}></div>
//                                 ))}
//                               </div>
//                               <div className="w-5 lg:w-6 h-2 lg:h-3 border border-black rounded-sm relative">
//                                 <div className="w-3 lg:w-4 h-1 lg:h-1.5 bg-green-500 rounded-sm m-0.5"></div>
//                               </div>
//                             </div>
//                           </div>
                          
//                           {/* App Content */}
//                           <div className="bg-gradient-to-b from-blue-50 to-white h-full p-3 sm:p-4 lg:p-6 flex flex-col">
//                             <div className="text-center mb-4 lg:mb-6">
//                               <div className="text-lg lg:text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
//                                 BidBox.ai
//                               </div>
//                               <p className="text-gray-500 text-xs lg:text-sm">Ad Preview Platform</p>
//                             </div>
                            
//                             <div className="flex-1 flex items-center justify-center">
//                               <div className="bg-white rounded-xl lg:rounded-2xl p-2 sm:p-3 lg:p-4 shadow-lg">
//                                 <div className="scale-75 sm:scale-100 origin-center">
//                                   <AdContent />
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   ) : (
//                     // Desktop Preview
//                     <div className="transform hover:scale-105 transition-transform duration-300 w-full max-w-[900px] lg:max-w-[1000px]">
//                       <div className="bg-white/80 backdrop-blur-xl rounded-2xl lg:rounded-3xl shadow-2xl overflow-hidden w-full h-[500px] sm:h-[600px]">
//                         {/* Browser Header */}
//                         <div className="bg-gray-100/80 backdrop-blur-sm px-4 lg:px-6 py-3 lg:py-4 border-b border-gray-200/50">
//                           <div className="flex items-center space-x-3 lg:space-x-4">
//                             <div className="flex space-x-2">
//                               <div className="w-2 lg:w-3 h-2 lg:h-3 bg-red-500 rounded-full"></div>
//                               <div className="w-2 lg:w-3 h-2 lg:h-3 bg-yellow-500 rounded-full"></div>
//                               <div className="w-2 lg:w-3 h-2 lg:h-3 bg-green-500 rounded-full"></div>
//                             </div>
//                             <div className="flex-1 bg-white/60 rounded-lg px-3 lg:px-4 py-1 lg:py-2 text-xs lg:text-sm text-gray-600 truncate">
//                               https://bidbox.ai/preview/{currentAd.creativeId}
//                             </div>
//                           </div>
//                         </div>
                        
//                         {/* Content */}
//                         <div className="p-4 sm:p-6 lg:p-12 h-full bg-gradient-to-br from-gray-50/50 to-blue-50/30 flex items-center justify-center">
//                           <div className="text-center">
//                             <div className="mb-4 sm:mb-6 lg:mb-8">
//                               <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-2">
//                                 Ad Creative Preview
//                               </h2>
//                               <p className="text-gray-500 text-sm lg:text-base">
//                                 {currentAd.name} • {currentAd.dimension}
//                               </p>
//                             </div>
                            
//                             <div className="relative">
//                               <div className="absolute -inset-4 bg-gradient-to-r from-blue-400/20 to-purple-400/20 rounded-2xl lg:rounded-3xl blur-xl"></div>
//                               <div className="relative bg-white/60 backdrop-blur-sm rounded-xl lg:rounded-2xl p-4 lg:p-8 border border-white/20 shadow-xl">
//                                 <AdContent />
//                               </div>
//                             </div>
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Right Sidebar */}
//             <div className="w-80 lg:w-96 bg-white/80 backdrop-blur-xl border-l border-white/20 shadow-xl p-4 lg:p-6 hidden xl:block flex-shrink-0 overflow-y-auto">
//               <div className="mb-6 lg:mb-8">
//                 <h3 className="text-lg lg:text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent mb-2">
//                   Creative Analytics
//                 </h3>
//                 <p className="text-sm text-gray-500">Real-time performance metrics</p>
//               </div>
              
//               {/* Ad Details Card */}
//               <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl lg:rounded-2xl p-4 lg:p-6 mb-4 lg:mb-6 border border-purple-100">
//                 <h4 className="font-bold text-purple-800 mb-3 lg:mb-4 flex items-center">
//                   <div className="w-2 h-2 bg-purple-600 rounded-full mr-2 animate-pulse"></div>
//                   Current Creative
//                 </h4>
//                 <div className="space-y-2 lg:space-y-3">
//                   <div className="flex justify-between">
//                     <span className="text-gray-600 font-medium text-sm">Dimension:</span>
//                     <span className="text-gray-800 font-bold text-sm">{currentAd.dimension}</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600 font-medium text-sm">Type:</span>
//                     <span className="text-gray-800 text-sm">Interactive Video</span>
//                   </div>
//                   <div className="flex justify-between">
//                     <span className="text-gray-600 font-medium text-sm">Creative ID:</span>
//                     <span className="text-gray-800 font-mono text-xs">{currentAd.creativeId}</span>
//                   </div>
//                 </div>
//               </div>

//               {/* Performance Metrics */}
//               <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-6 mb-6 border border-green-100">
//                 <h4 className="font-bold text-green-800 mb-4">Performance</h4>
//                 <div className="space-y-4">
//                   <div>
//                     <div className="flex justify-between mb-1">
//                       <span className="text-sm text-gray-600">Engagement Rate</span>
//                       <span className="text-sm font-bold text-green-600">94%</span>
//                     </div>
//                     <div className="w-full bg-gray-200 rounded-full h-2">
//                       <div className="bg-gradient-to-r from-green-500 to-emerald-500 h-2 rounded-full animate-pulse" style={{width: '94%'}}></div>
//                     </div>
//                   </div>
//                   <div>
//                     <div className="flex justify-between mb-1">
//                       <span className="text-sm text-gray-600">Click-through Rate</span>
//                       <span className="text-sm font-bold text-blue-600">3.2%</span>
//                     </div>
//                     <div className="w-full bg-gray-200 rounded-full h-2">
//                       <div className="bg-gradient-to-r from-blue-500 to-cyan-500 h-2 rounded-full" style={{width: '32%'}}></div>
//                     </div>
//                   </div>
//                   <div>
//                     <div className="flex justify-between mb-1">
//                       <span className="text-sm text-gray-600">View Completion</span>
//                       <span className="text-sm font-bold text-purple-600">87%</span>
//                     </div>
//                     <div className="w-full bg-gray-200 rounded-full h-2">
//                       <div className="bg-gradient-to-r from-purple-500 to-pink-500 h-2 rounded-full" style={{width: '87%'}}></div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* QR Code */}
//               <div className="bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-gray-200/50 text-center">
//                 <h4 className="font-bold text-gray-800 mb-4">Quick Access</h4>
//                 <div className="w-32 h-32 mx-auto mb-4 bg-white rounded-xl flex items-center justify-center shadow-sm">
//                   <QrCode size={80} className="text-gray-400" />
//                 </div>
//                 <p className="text-xs text-gray-500">
//                   Scan to view on mobile device
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TigerDetail;